<template>
  <v-dialog v-model="dialogProblem" max-width="500px" persistent max-height="500px" style="overflow-y: hidden;">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai hidden-sm-and-down"> <v-icon color="white">fas fa-bullhorn</v-icon>&nbsp;&nbsp; {{$t('Homepage.Dialog.titleReport')}} </v-toolbar-title>
          <v-toolbar-title class="white--text CSChatThai hidden-md-and-up"> <v-icon color="white">fas fa-bullhorn</v-icon>&nbsp;&nbsp; {{$t('Homepage.Dialog.titleReport')}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon flat @click.stop="closeDialog()">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text  style="padding-left: 30px;">
        <div style="background: white; padding-top: 2vh;">

          <v-layout align-center row wrap justify-center>
            <v-flex xs12 sm12 md12 xl12 lg12>
              <v-form v-model="valid" ref="form" class="CSChatThai labeltext">
              <v-text-field
              outline
              :label="$t('Homepage.Dialog.name')"
              v-model="name"
              :rules="nameRules"
              prepend-inner-icon="fas fa-user-circle"
            ></v-text-field>
              <v-text-field
              outline
              :label="$t('Homepage.Dialog.email')"
              v-model="email"
              :rules="emailRules"
              prepend-inner-icon="fas fa-envelope-square"
            ></v-text-field>
              <v-select
                :items="items.list_report"
                outline
                :label="$t('Homepage.Dialog.subject')"
                v-model="subject"
                :item-text="($i18n.locale == 'th')? 'category_TH':'category_ENG'"
                item-value="category_id"
                prepend-inner-icon="fas fa-exclamation-circle"
            ></v-select>
              <v-textarea
              outline
              :rules="detailRules"
              :label="$t('Homepage.Dialog.detail')"
              v-model="detail"
            ></v-textarea>
            <v-layout align-center row justify-center>
              <v-btn dark  style="background: #2562af !important; border-radius: 30px;"  @click="report()" v-if="valid">
                <span>{{$t('AnswerQuestion.sendme')}}</span>
              </v-btn>
              <v-btn v-else disabled style="border-radius: 30px;">
                <span>{{$t('AnswerQuestion.sendme')}}</span>
              </v-btn>
                <v-btn dark style="color: #2462ae !important; background: white !important;border-radius: 30px;"  @click="closeDialog()">
                  <span>{{$t('AnswerQuestion.cancel')}}</span>
                </v-btn>
              </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>
  </v-card>
  </v-dialog>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'

export default {
  props: {dialogProblem: false},
  data() {
    return {
      valid: false,
      name: '',
      email: '',
      subject: 'r1',
      detail: '',
      items: [],
      emailRules: [
        v => !!v || this.$t('Homepage.Dialog.inputEmail'),
        v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || this.$t('Homepage.Dialog.inputEmailError')
      ],
      nameRules: [
        v => !!v || this.$t('Homepage.Dialog.inputName')
      ],
      detailRules: [
        v => !!v || this.$t('Homepage.Dialog.inputDetail')
      ]
    }
  },
  created () {
    this.getsubject()
  },
  watch: {
  },
  computed: {
  },
  methods: {
    getsubject () {
      this.axios.post(process.env.APImanage + '/getcategory').then((response) => {
        if (response.data.status === 'success') {
          this.items = response.data
        }
      })
    },
    closeDialog () {
      this.valid = false
      this.subject = 'r1'
      this.detail = ''
      this.$emit('closeDialogProblem', false)
    },
    report () {
      let formData = new FormData()
      formData.append('phone', '')
      formData.append('email', this.email)
      formData.append('comment', this.detail)
      formData.append('name', this.name)
      formData.append('category_id', this.subject)
      this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
        if (response.data.status === 'success') {
          this.$swal('', this.$t('Alert.Success.success'), 'success')
          this.closeDialog()
        } else {
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          this.closeDialog()
        }
      }, () => {
        this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
      })
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.v-text-field .v-label {
overflow: inherit;
}

</style>



// WEBPACK FOOTER //
// src/components/homepage/ProblemDialog.vue